var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { BoundTextField } from "@twii/fabric-ui/lib/component/BoundTextField";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import { Dropdown } from "office-ui-fabric-react/lib/Dropdown";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import { getStyles } from "./DashboardAdd.styles";
import { getClassNames } from "./DashboardAdd.classNames";
var DashboardPropertyEditor = /** @class */ (function (_super) {
    __extends(DashboardPropertyEditor, _super);
    function DashboardPropertyEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DashboardPropertyEditor.prototype.render = function () {
        return (React.createElement("div", { className: "dashboard-property-editor" },
            React.createElement(BoundTextField, { label: "Title", binding: { target: this.props.dashboard, key: "title", setter: "setTitle" } })));
    };
    DashboardPropertyEditor = __decorate([
        observer
    ], DashboardPropertyEditor);
    return DashboardPropertyEditor;
}(React.Component));
var DashboardAddActions = /** @class */ (function (_super) {
    __extends(DashboardAddActions, _super);
    function DashboardAddActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClickCancel = function () {
            _this.props.add.cancel();
        };
        _this._onClickSave = function () {
            _this.props.add.save();
        };
        return _this;
    }
    DashboardAddActions.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement(DefaultButton, { className: this.props.actionClassName, onClick: this._onClickCancel }, "Cancel"),
            React.createElement(PrimaryButton, { className: this.props.actionClassName, onClick: this._onClickSave, disabled: !this.props.add.saveEnabled }, "OK")));
    };
    DashboardAddActions = __decorate([
        observer
    ], DashboardAddActions);
    return DashboardAddActions;
}(React.Component));
var ExistingDashboardSelector = /** @class */ (function (_super) {
    __extends(ExistingDashboardSelector, _super);
    function ExistingDashboardSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onChange = function (option) {
            var dashboard = _this.props.add.dashboardList.dashboards.find(function (db) { return db.id === option.key; });
            if (dashboard) {
                _this.props.add.setExisting(dashboard);
            }
        };
        return _this;
    }
    ExistingDashboardSelector.prototype.render = function () {
        if (this.props.add.dashboardList.dashboardCount > 0) {
            var options = this.props.add.dashboardList.dashboards.map(function (db) {
                return {
                    key: db.id,
                    text: db.title
                };
            });
            return React.createElement(Dropdown, { label: "From Existing", options: options, onChanged: this._onChange, selectedKey: this.props.add.existing ? this.props.add.existing.id : undefined });
        }
        return null;
    };
    ExistingDashboardSelector = __decorate([
        observer
    ], ExistingDashboardSelector);
    return ExistingDashboardSelector;
}(React.Component));
var DashboardAddEditor = /** @class */ (function (_super) {
    __extends(DashboardAddEditor, _super);
    function DashboardAddEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onKeyDown = function (e) {
            if (e.which === 13 /* enter */ && _this.props.add.saveEnabled) {
                _this.props.add.save();
            }
        };
        _this._onMakeActiveChange = function (e, checked) {
            _this.props.add.setMakeActive(checked);
        };
        return _this;
    }
    DashboardAddEditor.prototype.render = function () {
        if (this.props.add.active) {
            return (React.createElement("div", { className: this.props.className },
                React.createElement(DashboardPropertyEditor, { dashboard: this.props.add.dashboard }),
                React.createElement(ExistingDashboardSelector, __assign({}, this.props)),
                React.createElement(Checkbox, { label: "Set Dashboard Active", onChange: this._onMakeActiveChange, checked: this.props.add.makeActive, styles: { root: { marginTop: 8 } } })));
        }
        return null;
    };
    DashboardAddEditor = __decorate([
        observer
    ], DashboardAddEditor);
    return DashboardAddEditor;
}(React.Component));
var DashboardAddPanel = /** @class */ (function (_super) {
    __extends(DashboardAddPanel, _super);
    function DashboardAddPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderActions = function () {
            return React.createElement(DashboardAddActions, { add: _this.props.add, className: _this._classNames.actions, actionClassName: _this._classNames.action });
        };
        _this._onRenderEditor = function () {
            return React.createElement(DashboardAddEditor, { add: _this.props.add, className: _this._classNames.editor });
        };
        _this._onDismiss = function () {
            _this.props.add.cancel();
        };
        return _this;
    }
    DashboardAddPanel.prototype.render = function () {
        this._classNames = getClassNames(getStyles(null, this.props.styles), this.props.className);
        return (React.createElement(Panel, { className: this._classNames.root, isOpen: this.props.add.active, isLightDismiss: true, onRenderFooterContent: this._onRenderActions, onRenderBody: this._onRenderEditor, headerText: "Add Dashboard", type: PanelType.medium, onDismiss: this._onDismiss }));
    };
    DashboardAddPanel = __decorate([
        observer
    ], DashboardAddPanel);
    return DashboardAddPanel;
}(React.Component));
export { DashboardAddPanel };
